export const keys = {
  all: ['welcome-questionnaire'] as const,
} as const;
